import React from 'react';

const UserPanelInfo = ({ setVisible }) => {
  return (
    <div className="user-panel-info">
      <i
        className="dx-icon-info"
        onClick={() => setVisible(true)}
        role="presentation"
      />
    </div>
  );
};

export default UserPanelInfo;
